/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useRef, useState } from "react";
import ProfileService from "../Services/Profile";
import i18n, { _get_i18Lang } from "../i18n";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../Styles/Profile.css";
// import {
//   AudioListButton,
//   BookListButton,
//   FavouriteArticals,
//   FavouriteVideos,
//   MarkList,
// } from "./LogInoutModel";
import { AudioListButton } from "../Components/AudioListButton";
import { MarkList } from "../Components/MarkList";
import { FavouriteArticals } from "../Components/FavouriteArticals";
import { FavouriteVideos } from "../Components/FavouriteVideos";
import ProfileSidePanel from "./ProfileSidePanel";
import { BookContentType } from "./Epub";
import Loading from "../Components/Loading";
import Loader from "./Loader";
import { useVideo } from "../Contexts/VideosContext";
import VideoService from "../Services/VideoPlayer";
import { userId } from "../Contexts/LocaleContext";
import { FavouriteBooks } from "../Components/FavouriteBooks";

export const ProfileFav = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [bookFav, getBookFav] = useState<any>([]);
  const [kalyan, getKalyan] = useState<any>([]);
  const [kalpatru, getKalpatru] = useState<any>([]);
  const [geetgovind, getGeetGovind] = useState<any>([]);
  const [pravachan, getPravachan] = useState<any>([]);
  const [audio, getAudio] = useState<any>([]);
  const [dailySatsang, getDailySatsang] = useState<any>([]);
  const [article, getArticle] = useState<any>([]);
  const [vivek, getVivek] = useState<any>([]);
  const [refresh, setRefresh] = useState<boolean>(false);

  const [bookMark, getBookMark] = useState<any>([]);
  const [kalyanMark, getKalyanMark] = useState<any>([]);
  const [kalpatruMark, getKalpatruMark] = useState<any>([]);
  const [geetgovindMark, getGeetGovindMark] = useState<any>([]);
  const [vivekMark, getVivekMark] = useState<any>([]);
  const [videos, getVideos] = useState<any>([]);

  const [loading, setLoading] = useState(true); // Loader state
  const [isVideoClicked, setIsVideoClicked] = useState<boolean>(false);

  const colors = "#FF9800";

  const initialDisplayCount = 4;
  const { setYoutubetitle, setHideModal, setIsPiP, setOpen, setVideoId, setVideoObjId, setIsLiked, likedMsg, isLiked, setLikedMsg } = useVideo();

  useEffect(() => {
    // setRefresh(false);
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await ProfileService.getfavData(0, 50);
        const res = await response;
        getBookFav(res?.result?.books);
        getKalyan(res?.result?.kalyans);
        getKalpatru(res.result?.kalyansKalpataru);
        getGeetGovind(res?.result?.monthlyMagazine);
        getPravachan(res?.result?.pravachans);
        getAudio(res?.result?.audios);
        getDailySatsang(res?.result?.audioPodcasts)
        getArticle(res?.result?.articles);
        getVivek(res?.result?.vivekVanis);

        getBookMark(res?.result?.bookMarks);
        getKalyanMark(res?.result?.kalyanMarks);
        getKalpatruMark(res?.result?.kalyanKalpatarusMarks);
        getGeetGovindMark(res?.result?.monthlyMagazinesMarks);
        getVivekMark(res?.result?.vivekVaniMarks);
        getVideos(res?.result?.videos);
        // setYoutubetitle(res?.result?.videos[0]?.name)

      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    };
    fetchData();
  }, [refresh, i18n.language]);

  const isVideoClickedRef = useRef(false);

  const playVideo = (videos: any) => {

    if (localStorage.getItem("Token")) {

      VideoService.getSpecificVideo(videos?.id, userId).then((res) => {
        if (res?.status) {
          setYoutubetitle(res?.result?.name);
          setIsLiked(res?.result?.isFavourite)
          setVideoObjId(res?.result?.id)
          setVideoId(res?.result?.videoHash)
          setOpen(true)
          setIsPiP(false)
          setHideModal(true);

        }
      })
    }
  }

  return (
    <div>
      <div
        className="breadcrumbs-head newcontainer"
        style={{
          width: "100%",
          marginTop: "-175px",
          background: "none",
          backgroundColor: "#ffedbc",
          height: "240px",
          borderBottom: "2px solid #fff",
          paddingTop: 0,
        }}
      >
        <div className="breadcrumbs">
          <div
            className="containers"
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "rgb(209, 21, 1)",
              top: "155px",
              fontFamily: "ChanakyaUniBold",
            }}
          >
            {t("myFavourites_tr")}
            <div
              style={{
                fontSize: "19px",
                fontWeight: 600,
                color: "#2d2a29",
                marginTop: "-8px",
              }}
            >
              <Link style={{ marginRight: "4px", color: "#2d2a29" }} to="/">
                {t("Home_tr")}
              </Link>
              <span style={{ color: "#2d2a29" }}>/ {t("myFavourites_tr")}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        className="newcontainer"
        style={{
          backgroundColor: "#FFF6E1",
          padding: "25px 0 3% 0",
          marginTop: 0,
        }}
      >
        <div className="containers" style={{ height: "" }}>
          <div className="row">
            <ProfileSidePanel
              color={colors}
              ImageOfUser={undefined}
            />
            <div className="col-9">
              {loading ? (
                <div>{loading && <Loader loading={loading} />}</div>
              ) : bookFav?.length === 0 &&
                kalyan?.length === 0 &&
                kalpatru?.length === 0 &&
                geetgovind?.length === 0 &&
                pravachan?.length === 0 &&
                audio?.length === 0 &&
                article?.length === 0 &&
                vivek?.length === 0 &&
                bookMark?.length === 0 &&
                kalyanMark?.length === 0 &&
                kalpatruMark?.length === 0 &&
                geetgovindMark?.length === 0 &&
                vivekMark?.length === 0 &&
                videos?.length === 0 ? (
                <div
                  style={{
                    boxShadow: "0 0 7px 1px #f5deb1",
                    textAlign: "center",
                    paddingTop: "10%",
                    height: "100%",
                  }}
                >
                  <h1
                    style={{ fontSize: "30px", fontFamily: "ChanakyaUniBold" }}
                  >
                    {t("no_data_available_tr")}
                  </h1>
                </div>
              ) : (
                <div
                  className="tab-pane fade show active"
                  id="e-books"
                  role="tabpanel"
                  style={{
                    overflow: "hidden",
                    boxShadow: "0 0 7px 1px #f5deb1",
                  }}
                  aria-labelledby="e-books-tab"
                >
                  <div
                    className="tab-row"
                    style={{ marginTop: 0, display: "contents" }}
                  >
                    <div
                      className="tabscroll"
                      style={{ paddingTop: 0, display: "contents" }}
                    >
                      <div
                        className="row"
                        style={{
                          //  background: "#FFFAF0",
                          padding: "15px 10px",
                        }}
                      >
                        <FavouriteBooks
                          type="book"
                          title={t("E_books_tr")}
                          books={bookFav}
                          getBook={(book) => {
                            navigate("/books/" + book.slug, {
                              state: {
                                bookId: book.id,
                                bookName: book.name,
                                bookSlug: book.slug,
                                special: window.location.pathname,
                              },
                            });
                          }}
                        />

                        <MarkList
                          bookMarks={bookMark}
                          marktitle={t("book_mark_tr")}
                          getMarks={(bookMark) => {
                            navigate(`/reader/books/` + bookMark?.slug, {
                              state: {
                                bookDetailId: bookMark.id,
                                titleName: bookMark.name,
                                location: bookMark.cfi,
                                slug: bookMark.slug,
                                label: bookMark.label,
                                type: BookContentType.books,
                              },
                            });
                          }}
                        />

                        <FavouriteBooks
                          type="kalyan"
                          title={t("Kalyan_tr")}
                          books={kalyan}
                          getBook={(kalyan) => {
                            navigate(`/kalyan/` + kalyan.slug, {
                              state: { kalyanId: kalyan.id },
                            });
                          }}
                        />

                        <MarkList
                          bookMarks={kalyanMark}
                          marktitle={t("Kalyan_mark_tr")}
                          getMarks={(kalyanMark) => {
                            navigate(`/reader/kalyan/` + kalyanMark.slug, {
                              state: {
                                kalyanDetailId: kalyanMark.id,
                                titleName: kalyanMark.name,
                                location: kalyanMark.cfi,
                                slug: kalyanMark.slug,
                                label: kalyanMark.label,
                                type: BookContentType.kalyan,
                              },
                            });
                          }}
                        />

                        <FavouriteBooks
                          type="kalpatru"
                          title={t("Kalyan_Kalpataru_tr")}
                          books={kalpatru}
                          getBook={(kalpatru) => {
                            navigate(`/kalyanakalpataru/` + kalpatru.slug, {
                              state: { kalpatruId: kalpatru.id },
                            });
                          }}
                        />

                        <MarkList
                          bookMarks={kalpatruMark}
                          marktitle={t("Kalyan_Kalpataru_mark_tr")}
                          getMarks={(kalpatruMark) => {
                            navigate(
                              `/reader/kalyanakalpataru/` + kalpatruMark.slug,
                              {
                                state: {
                                  kalpatrauDetailId: kalpatruMark.id,
                                  titleName: kalpatruMark.name,
                                  location: kalpatruMark.cfi,
                                  slug: kalpatruMark.slug,
                                  label: kalpatruMark.label,
                                  type: BookContentType.kalpatru,
                                },
                              }
                            );
                          }}
                        />

                        <FavouriteBooks
                          type="geetgovind"
                          title={t("MonthlyMagazine_tr")}
                          books={geetgovind}
                          getBook={(kalpatru) => {
                            navigate(`/geetgovind/` + kalpatru.slug, {
                              state: { MonthId: kalpatru.id },
                            });
                          }}
                        />

                        <MarkList
                          bookMarks={geetgovindMark}
                          marktitle={t("MonthlyMagazine_mark_tr")}
                          getMarks={(geetgovindMark) => {
                            navigate(
                              `/reader/geetgovind/` + geetgovindMark.slug,
                              {
                                state: {
                                  magazineDetailId: geetgovindMark.id,
                                  titleName: geetgovindMark.name,
                                  location: geetgovindMark.cfi,
                                  slug: geetgovindMark.slug,
                                  label: geetgovindMark.label,
                                  type: BookContentType.magazine,
                                },
                              }
                            );
                          }}
                        />

                        <FavouriteBooks
                          type="vivek"
                          title={t("vivek_vani_tr")}
                          books={vivek}
                          getBook={(vivek) => {
                            navigate(`/vivekvani/` + vivek.slug, {
                              state: { vivekId: vivek?.id },
                            });
                          }}
                        />

                        <MarkList
                          bookMarks={vivekMark}
                          marktitle={t("vivek_vani_mark_tr")}
                          getMarks={(vivekMark) => {
                            navigate(`/reader/vivekvanis/` + vivekMark.slug, {
                              state: {
                                vivekvaniDetailId: vivekMark.id,
                                titleName: vivekMark.name,
                                location: vivekMark.cfi,
                                slug: vivekMark.slug,
                                label: vivekMark.label,
                                type: BookContentType.vivek,
                              },
                            });
                          }}
                        />

                        <AudioListButton
                          title={t("Pravachan_tr")}
                          audios={pravachan}
                          getAudios={(audio) => {
                            localStorage.setItem("type", "pravachans");
                            navigate(`/pravachans/${encodeURIComponent(audio.slug)}`, {
                              state: {
                                type: pravachan,
                                audioId: audio.id,
                                audioslug: audio.slug,
                              },
                            });
                          }}
                        />

                        <AudioListButton
                          title={t("Audios_tr")}
                          audios={audio}
                          getAudios={(audio) => {
                            localStorage.setItem("type", "audios");
                            navigate(`/audios/${encodeURIComponent(audio.slug)}`, {
                              state: {
                                type: "audios",
                                audioId: audio.id,
                                audioslug: audio.slug,
                              },
                            });
                          }}
                        />

                        <AudioListButton
                          title={t("daily_satsang_tr")}
                          audios={dailySatsang}
                          getAudios={(audio) => {
                            localStorage.setItem("type", "DailySatsang");
                            navigate(`/DailySatsang/${encodeURIComponent(audio.slug)}`, {
                              state: {
                                type: "DailySatsang",
                                audioId: audio.id,
                                audioslug: audio.slug,
                              },
                            });
                          }}
                        />

                        <FavouriteArticals
                          title={t("Article_tr")}
                          article={article}
                          getArtical={(artical) => {
                            navigate(`/articles/` + artical.slug, {
                              state: {
                                articleId: artical.id,
                                articleName: artical.name,
                              },
                            });
                          }}
                        />

                        <FavouriteVideos
                          title={t("Video_tr")}
                          videos={videos}
                          getVideos={(videos) => {
                            playVideo(videos)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
